var slider = new bstackSlider({
  selector: ".bstack-rows-container",
  cssClass: [],
  rows: 2,
  slide: {
    1300: 4,
    980: 3,
    640: 2,
    320: 1
  },
  gap: {
    1300: 21,
    980: 21,
    640: 21,
    320: 21
  }
});